export default process.env.NODE_ENV === "development"
  ? "http://localhost:8080/dashboard"
  : "https://dashboard.steinhq.com/api";